'use strict';
/* jshint ignore:start */

var hampers = {

		hamperFiltersEvent: function (e) {
			if ($('input[name=currentHamper]').length > 0) {
				var hamper = JSON.parse($('input[name=currentHamper]').val());
			}
			var obj = {
				event: 'hamperFilters'
			};
			obj["category_filter_chocolate"] = getChocolateTypeFilters();
			obj["category_filter_price"] =  $('#price-refinement-link').length > 0 ? $('#price-refinement-link').data('minprice') + '-' + $('#price-refinement-link').data('maxprice') : '';
			obj["category_items_number"] = $('span.search-total-count').text();
			obj["category_name"] = hamper.category_name;
			obj["category_sort"] =  $('#grid-sort-header').find('option:selected').text(),
			obj["category_view"] = 'grid';
			obj["re_hamper_component"] = hamper.re_hamper_component;
			obj["re_hamper_subtotal_val"] = hamper.re_hamper_subtotal_val;
			obj["re_hamper_total_items"] = hamper.re_hamper_total_items;
			obj["re_nut_allergy"] = hamper.re_nut_allergy;
			obj["category_filter_diet"] = '[' + getDietaryFilter(e) + ']';
			obj["category_filter_gift"] =  '[' + getHamperProductTypeFilter(e) + ']';
			obj["category_filter_product"] =  '[' + getProductTypeFilter(e) + ']';

			dataLayer.push(obj);
		},

		hamperAddToBagEvent: function (e, params) {
			if ($('input[name=currentHamper]').length > 0) {
				var hamper = JSON.parse($('input[name=currentHamper]').val());
			}
			var hamperContainerDataEl = $('input[name="hamperContainerDetails"]'),
				hamperContainer;
			if (hamperContainerDataEl.length > 0) {
				hamperContainer = JSON.parse(hamperContainerDataEl.val());
			}
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				event: 'hamperAddToBag'
			};

			obj["re_hamper_component"] = hamper.re_hamper_component;
			obj["re_hamper_subtotal_val"] = hamper.re_hamper_subtotal_val;
			obj["re_hamper_total_items"] = hamper.re_hamper_total_items;
			obj["re_number_of_hampers"] = hamper.hamper_quantity;
			obj["re_wheat_allergy "] = hamper.re_wheat_allergy ;

			$.extend(obj, getHamperData());
			$.extend(obj, getHamperContainerData(hamperContainer));
			$.extend(obj, getHamperProductData(obj));

			dataLayer.push(obj);
		},

		saveHamperEvent: function (params) {
			if ($('input[name=currentHamper]').length > 0) {
				var hamper = JSON.parse($('input[name=currentHamper]').val());
				// object to be pushed
				var obj = {
					button_ID: params.options.dialogClass ? params.options.dialogClass : params.options.title,
					event: 'saveHamper'
				};
				obj["re_hamper_component"] = hamper.re_hamper_component;
				obj["re_hamper_subtotal_val"] = hamper.re_hamper_subtotal_val;
				obj["re_hamper_total_items"] = hamper.re_hamper_total_items
				obj["re_nut_allergy"] = hamper.re_nut_allergy;
				$.extend(obj, getHamperData());
				$.extend(obj, getHamperProductData());
				dataLayer.push(obj);
			}
		},

		updateHamperInBagEvent: function (e) {
			if ($('input[name=currentHamper]').length > 0) {
				var hamper = JSON.parse($('input[name=currentHamper]').val());
			}
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				event: 'updateHamperInBag'
			};
			obj["re_hamper_component"] = hamper.re_hamper_component;
			obj["re_hamper_subtotal_val"] = hamper.re_hamper_subtotal_val;
			obj["re_hamper_total_items"] = hamper.re_hamper_total_items;
			obj["re_nut_allergy"] = hamper.re_nut_allergy;
			obj["re_wheat_allergy"] = hamper.re_wheat_allergy;

			$.extend(obj, getHamperData());
			$.extend(obj, getProductDetailData(data));
			dataLayer.push(obj);
		},

		hamperSortEvent: function (e) {
			if ($('input[name=currentHamper]').length > 0) {
				var hamper = JSON.parse($('input[name=currentHamper]').val());
			}
			if (e.target.selectedOptions !== 'undefined') {
				var sortOption = e.target.selectedOptions[0].innerText;
				var obj = {
					event: 'hamperSort'
				};
				obj["category_filter_chocolate"] = getChocolateTypeFilters();
				obj["category_filter_offers"] = '';
				obj["category_filter_price"] = $('#price-refinement-link').length > 0 ? $('#price-refinement-link').data('minprice') + '-' + $('#price-refinement-link').data('maxprice') : '';
				obj["category_filter_rating"] = '';
				obj["category_items_number"] = $('span.search-total-count').text();
				obj["category_name"] = hamper.category_name;
				obj["category_page_number"] = '';
				obj["category_sort"] = sortOption;
				obj["category_view"] = 'grid';
				obj["re_hamper_component"] = hamper.re_hamper_component;
				obj["re_hamper_subtotal_val"] = hamper.re_hamper_subtotal_val;
				obj["re_hamper_total_items"] = hamper.re_hamper_total_items
				obj["re_nut_allergy"] = hamper.re_nut_allergy;
				obj["category_filter_diet"] = '[' + getDietaryFilter(e) + ']';
				obj["category_filter_gift"] =  '[' + getHamperProductTypeFilter(e) + ']';
				obj["category_filter_product"] =  '[' + getProductTypeFilter(e) + ']';

				dataLayer.push(obj);
			}
		},

	removeItemFromHamperEvent: function (e, data) {
		if ($('input[name=currentHamper]').length > 0) {
			var hamper = JSON.parse($('input[name=currentHamper]').val());
		}
		var obj = {
			button_ID: e.target.id ? e.target.id : e.target.innerText,
			event: 'removeItemFromHamper'
		};

		obj["re_hamper_component"] = hamper.re_hamper_component;
		obj["re_hamper_subtotal_val"] = hamper.re_hamper_subtotal_val;
		obj["re_hamper_total_items"] = hamper.re_hamper_total_items;
		obj["re_nut_allergy"] = hamper.re_nut_allergy;
		obj["re_wheat_allergy"] = hamper.re_wheat_allergy;

		$.extend(obj, getHamperData());
		$.extend(obj, getProductDetailData(data));
		dataLayer.push(obj);
	},

	hamperSelectEvent: function (e) {
		if ($('input[name=currentHamper]').length > 0) {
			var hamper = JSON.parse($('input[name=currentHamper]').val());
		}

		var obj = {
			'event': 'hamperSelect',
			'button_ID': e.target.id ? e.target.id : e.target.innerText
		};

		obj["re_wheat_allergy"] = hamper.re_wheat_allergy;

		$.extend(obj, getHamperData());
		dataLayer.push(obj);
	},

	addItemToHamperEvent: function (e, data) {
		if ($('input[name=currentHamper]').length > 0) {
			var hamper = JSON.parse($('input[name=currentHamper]').val());
		}
		var hamperContainerDataEl = $('input[name="hamperContainerDetails"]');
		if (hamperContainerDataEl.length > 0) {
			var hamperContainer = JSON.parse(hamperContainerDataEl.val());
		}
		var hamperItemsCountEl = $('#currentHamperItemCount'),
			hamperItemsCount;
		if (hamperItemsCountEl.length > 0) {
			hamperItemsCount = hamperItemsCountEl.data('item-count');
		}
		var obj = {
			'event': 'addItemToHamper',
			'button_ID': e.target.id ? e.target.id : e.target.innerText
		};
		$.extend(obj, getHamperData());
		$.extend(obj, getProductDetailData(data));
		$.extend(obj, getHamperContainerData(hamperContainer));
		fillProductSetData(obj, obj);
		obj["hamper_items_added"] = +hamperItemsCount;
		obj["re_hamper_component"] = obj["product_ID"];
		obj["re_hamper_subtotal_val"] = obj["hamper_price"];
		obj["re_hamper_total_items"] = obj["hamper_items_added"];
		obj["re_number_of_hampers"] = obj["hamper_quantity"];
		obj["re_wheat_allergy"] = hamper.re_wheat_allergy;

		dataLayer.push(obj);
	},

	hamperSearchEvent: function (e, query) {
		var obj = {
			'event': 'hamperSearch',
			'button_ID': e.target.id ? e.target.id : e.target.innerText,
			'search_keyword': query[0].value
		};
		obj["category_filter_chocolate"] = getChocolateTypeFilters(),
		obj["category_filter_offers"] = '',
		obj["category_filter_diet"] = '[' + getDietaryFilter(e) + ']';
		obj["category_filter_gift"] =  '[' + getHamperProductTypeFilter(e) + ']';
		obj["category_filter_price"] = '',
		obj["category_filter_product"] =  '[' + getProductTypeFilter(e) + ']';
		obj["category_filter_rating"] = '',
		obj["category_items_number"] = $('span.search-total-count').text(),
		obj["category_name"] = '',
		obj["category_page_number"] = '',
		obj["category_sort"] = $('#grid-sort-header').find('option:selected').text(),
		obj["category_view"] = 'grid',
		obj["search_results_returned"] = '',
		dataLayer.push(obj);
	},

	hamperViewEvent: function () {
		if ($('input[name=currentHamper]').length > 0) {
			var hamper = JSON.parse($('input[name=currentHamper]').val());
		}
		var obj = {
				'event': 'hamperView',
				'button_ID': ''
			};
		obj["category_filter_chocolate"] = getChocolateTypeFilters(),
		obj["category_filter_offers"] = '',
		obj["category_filter_diet"] = '[' + getDietaryFilters() + ']';
		obj["category_filter_gift"] =  '[' + getHamperProductTypeFilters() + ']';
		obj["category_filter_price"] = '',
		obj["category_filter_product"] =  '[' + getProductTypeFilters() + ']';
		obj["category_filter_rating"] = '',
		obj["category_items_number"] = $('span.search-total-count').text(),
		obj["category_name"] = hamper ? hamper.category_name : '',
		obj["category_page_number"] = '',
		obj["category_sort"] = $('#grid-sort-header').find('option:selected').text(),
		obj["category_view"] = 'grid',
		dataLayer.push(obj);

	},

	viewHamperItemsEvent: function () {
		var obj = {
			'event': 'viewHamperItems',
			'button_ID': ''
		};
		$.extend(obj, getHamperData());
		$.extend(obj, getHamperProductData());
		dataLayer.push(obj);
	}
}
/**
 * @param event
 * @description Takes data which is available on a page
 */
function getHamperData() {
	if ($('input[name=currentHamper]').length > 0) {
		var currentHamper = JSON.parse($('input[name=currentHamper]').val());
		// object to be pushed
		var obj = {
			'hamper_name': currentHamper.hamper_name,
			'hamper_price': currentHamper.hamper_price,
			'hamper_quantity': currentHamper.hamper_quantity,
			'hamper_capacity': currentHamper.hamper_capacity,
			'hamper_size': currentHamper.hamper_size,
			'hamper_SKU': currentHamper.hamper_SKU,
			'hamper_type': currentHamper.hamper_type
		};
		return obj;
	}
}

/**
 * @param event
 * @description Takes data which is available on a page
 */
function getProductDetailData(data) {
	if ($('input[name=' + data.pid + ']').length > 0) {
		var product = JSON.parse($('input[name=' + data.pid + ']').val());
		// object to be pushed
		var obj = {};
		obj["product_ID"] = product.product_ID;
		obj["product_brand"] = product.product_brand;
		obj["product_category"] = product.product_category;
		obj["product_hierarchy"] = product.product_hierarchy;
		obj["product_name"] = product.product_name;
		obj["product_SKU"] = product.product_SKU;
		obj["product_price"] = product.product_price;
		obj["product_discount"] = product.product_discount;
		obj["product_price_old"] = product.product_price_old;
		obj["product_quantity"] = data.Quantity;
		obj["product_stock_status"] = product.product_stock_status;
		obj["product_variant"] = product.product_variant;
		obj["product_vat"] = product.product_vat;
		obj["product_set_capacity"] = product.product_set_capacity;
		obj["product_set_items_added"] = product.product_set_items_added;
		obj["product_set_name"] = product.product_set_name;
		obj["product_set_price"] = product.product_set_price;
		obj["product_set_size"] = product.product_set_size;
		obj["product_set_SKU"] = product.product_set_SKU;
		obj["product_set_type"] = product.product_set_type;

		return obj;
	}
}

/**
 * @description Returns concatenated string of checked filter labels from  section
 */
function getHamperProductTypeFilter(e) {
	var featureFilter = '';
	var selectedFilter = '';
	if (e) {
		if (e.target.id == 'hampers-your-items') {
			selectedFilter = e.target.innerText;
		}
		featureFilter = selectedFilter.trim();
		$('#secondary #hampers-your-items a').each(function () {
			if ($(this).hasClass('checked')) {
				if (featureFilter === '') {
					featureFilter = $(this).text().trim();
				} else {
					featureFilter += ' | ' + $(this).text().trim();
				}
			}
		});
	}
	return featureFilter;
}

/**
 * @description Returns concatenated string of checked filter labels from  section
 */
function getHamperProductTypeFilters() {
	var featureFilter = '';
	$('#secondary #hampers-your-items a').each(function () {
		if ($(this).hasClass('checked')) {
			if (featureFilter === '') {
				featureFilter = $(this).text().trim();
			} else {
				featureFilter += ' | ' + $(this).text().trim();
			}
		}
	});
	return featureFilter;
}
/**
 * @description Returns concatenated string of checked filter labels from  section
 */
function getProductTypeFilter(e) {
	var featureFilter = '';
	var selectedFilter = '';
	if (e) {
		if ($(e.target.offsetParent).hasClass('productType')) {
			selectedFilter = e.target.innerText;
		}
		featureFilter = selectedFilter.trim();
		$('#secondary .productType a').each(function () {
			if ($(this).hasClass('checked')) {
				if (featureFilter === '') {
					featureFilter = $(this).text().trim();
				} else {
					featureFilter += ' | ' + $(this).text().trim();
				}
			}
		});
	}
	return featureFilter;
}

/**
 * @description Returns concatenated string of checked filter labels from  section
 */
function getProductTypeFilters() {
	var featureFilter = '';
$('#secondary .productType a').each(function () {
	if ($(this).hasClass('checked')) {
		if (featureFilter === '') {
			featureFilter = $(this).text().trim();
		} else {
			featureFilter += ' | ' + $(this).text().trim();
		}
	}
});
	return featureFilter;
}

/**
 * @description Returns concatenated string of checked filter values from  section
 */
function getDietaryFilter(e) {
	var featureFilter = '';
	var selectedFilter = '';
	if (e) {
		if ($(e.target.offsetParent).hasClass('dietary')) {
			selectedFilter = e.target.innerText;
		}
		featureFilter = selectedFilter.trim();
		$('#secondary .dietary a').each(function () {
			if ($(this).hasClass('checked')) {
				if (featureFilter === '') {
					featureFilter =  $(this).text().trim();
				} else {
					featureFilter += ' | ' + $(this).text().trim();
				}
			}
		});
	}
	return featureFilter;
}

/**
 * @description Returns concatenated string of checked filter values from  section
 */
function getDietaryFilters() {
	var featureFilter = '';
	$('#secondary .dietary a').each(function () {
		if ($(this).hasClass('checked')) {
			if (featureFilter === '') {
				featureFilter =  $(this).text().trim();
			} else {
				featureFilter += ' | ' + $(this).text().trim();
			}
		}
	});
	return featureFilter;
}

/**
 * @param event
 * @description Takes data which is available on a page
 */
function getHamperProductData(hamperContainerObj) {
	if ($('input[name=currentHamper]').length > 0) {
		var currentHamper = JSON.parse($('input[name=currentHamper]').val());
		var productArray = [];
		var productObj = [];
		for (var i = 0; i < currentHamper.product.length; i++) {
			// object to be pushed
			var obj = {};
			obj["product_brand"] = currentHamper.product[i].product_brand;
			obj["product_category"] = currentHamper.product[i].product_category;
			obj["product_hierarchy"] = currentHamper.product[i].product_hierarchy;
			obj["product_name"] = currentHamper.product[i].product_name;
			obj["product_ID"] = currentHamper.product[i].product_ID;
			obj["product_SKU"] = currentHamper.product[i].product_SKU;
			obj["product_discount"] = currentHamper.product[i].product_discount;
			obj["product_price"] = currentHamper.product[i].product_price;
			obj["product_price_old"] = currentHamper.product[i].product_price_old;
			obj["product_quantity"] = currentHamper.product[i].product_quantity;
			obj["product_stock_status"] = currentHamper.product[i].product_stock_status;
			obj["product_variant"] = currentHamper.product[i].product_variant;
			obj["product_vat"] = currentHamper.product[i].product_vat;
			if (hamperContainerObj) {
				fillProductSetData(obj, hamperContainerObj)
			} else {
				obj["product_set_capacity"] = currentHamper.product[i].product_set_capacity;
				obj["product_set_items_added"] = currentHamper.product[i].product_set_items_added;
				obj["product_set_name"] = currentHamper.product[i].product_set_name;
				obj["product_set_price"] = currentHamper.product[i].product_set_price;
				obj["product_set_size"] = currentHamper.product[i].product_set_size;
				obj["product_set_SKU"] = currentHamper.product[i].product_set_SKU;
				obj["product_set_type"] = currentHamper.product[i].product_set_type;
			}
			productArray.push(obj);
		}
		productObj["product"] = productArray;
		return productObj;
	}
}
/**
 * Returns string with chocolate type filters delimited by |
 *
 * @returns {String}
 */
function getChocolateTypeFilters() {
	var chocolateFilters = '';
	if ($('div.chocolateTypes').find('a.checked').length > 0) {
		$('div.chocolateTypes').find('a.checked').each(function () {
			if (chocolateFilters !== '') {
				chocolateFilters += '|' + $(this).text().trim();
			} else {
				chocolateFilters += $(this).text().trim();
			}
		});
	}
	return chocolateFilters;
}

/**
 * Returns object with hamper container data
 *
 * @param hamperContainer {Object}
 */
function getHamperContainerData(hamperContainer) {
	var obj = {};
	if (!hamperContainer) {
		return obj;
	}

	var hamperSizeRegex = /^(\w+)\b/,
		hamperSizeMatch = hamperSizeRegex.exec(hamperContainer.name),
		hamperSize = (hamperSizeMatch && hamperSizeMatch[1]) ? hamperSizeMatch[1].toLowerCase() : '',
		hamperCapacitySize = hamperSize ? hamperSize + ' hamper|' : '',
		hamperCapacity = hamperCapacitySize + hamperContainer.rangeMinimum + '-' + hamperContainer.rangeMaximum + ' items';

	obj["hamper_type"] = hamperContainer.type;
	obj["hamper_size"] = hamperSize;
	obj["hamper_capacity"] = hamperCapacity;

	return obj;
}

/**
 * Sets product_set fields from hamper container fields
 *
 * @param obj {Object}
 */
function fillProductSetData(obj, hamperContainerObj) {
	obj["product_set_capacity"] = hamperContainerObj["hamper_capacity"];
	obj["product_set_name"] = hamperContainerObj["hamper_name"];
	obj["product_set_price"] = hamperContainerObj["hamper_price"];
	obj["product_set_size"] = hamperContainerObj["hamper_size"];
	obj["product_set_SKU"] = hamperContainerObj["hamper_SKU"];
	obj["product_set_type"] = hamperContainerObj["hamper_type"];

	return obj;
}

module.exports = hampers;
/* jshint ignore:end */
